import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'

import 'styles/ChecComponents.css'

const ChecTooltip = ({
  children,
  placement,
  title,
  overlayClassName,
  overlayStyle,
  align,
  trigger,
  arrowPointAtCenter,
  className,
  visible,
  onVisibleChange,
  childWrapClassName,
  childWrapStyle,
}) => {
  // Use controlled visibility when onVisibleChange is provided
  const visibilityProps = onVisibleChange
    ? { visible, onVisibleChange }
    : { defaultVisible: visible }

  // Only add style prop when childWrapStyle has values (avoids snapshot test changes)
  const childWrapProps = {
    className: childWrapClassName,
    ...(Object.keys(childWrapStyle).length > 0 && { style: childWrapStyle }),
  }

  return (
    <Tooltip
      placement={placement}
      align={align}
      title={title}
      overlayClassName={overlayClassName}
      overlayStyle={overlayStyle}
      trigger={trigger}
      arrowPointAtCenter={arrowPointAtCenter}
      className={`chec-tooltip ${className}`}
      {...visibilityProps}
    >
      <span {...childWrapProps}>{children}</span>
    </Tooltip>
  )
}

ChecTooltip.defaultProps = {
  arrowPointAtCenter: true,
  trigger: 'hover',
  className: '',
  overlayClassName: '',
  childWrapClassName: '',
  childWrapStyle: {},
  visible: false,
  onVisibleChange: null,
  overlayStyle: {},
}

ChecTooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),

  placement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
  ]),
  overlayClassName: PropTypes.string,
  trigger: PropTypes.oneOf(['hover', 'focus', 'click', 'contextMenu']),
  className: PropTypes.string,
  childWrapClassName: PropTypes.string,
  arrowPointAtCenter: PropTypes.bool,
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  align: PropTypes.any,
  overlayStyle: PropTypes.object,
  childWrapStyle: PropTypes.object,
}

export default ChecTooltip
